<!-- 人员统计报表 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
      <el-row class="top-first-line">
        <el-col :span="4">
            <el-form-item label="统计周期：">
              <el-select v-model="options.value" >
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                 >
              </el-option>
            </el-select>
          </el-form-item>
          </el-col >
      </el-row>
    </div>
    
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
         :header-cell-style="{background:'#F2F2F2',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            prop="IMEIdata"
            label="会员总数"
            >
          </el-table-column>
          <el-table-column
            prop="name"
            label="活跃会员数"
            >
          </el-table-column>
          <el-table-column
          prop="laiyuan"
          label='终端单位'
          >
          </el-table-column>
          <el-table-column
            prop="danwei"
            label="活跃终端数"
            >
          </el-table-column>
          <el-table-column
            prop="shoujihao"
            label="GPS点数"
            >
          </el-table-column >
          <el-table-column
            prop="danwei"
            label="基站点数"
            >
          </el-table-column>
          <el-table-column
            prop="danwei"
            label="混合点数"
            >
          </el-table-column>
          <el-table-column
            prop="danwei"
            label="统计周期"
            >
          </el-table-column>
         
        </el-table>
        <!-- <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="1000"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div> -->
      </el-row>
    </div>
    <!-- 修改 -->
    <!-- <Revise  v-if="reviseShow" @reviseShow='fatherReviseShow'></Revise>
    <LeadingIn v-if="LeadingInShow" @leadingInShow='fatherleadingInShow'></LeadingIn> -->
  </div>
</template>

<script>
//   import Revise from './revise/index.vue'
//   import LeadingIn from './leading-in/index.vue'
export default {
  components: {
  //   Revise,LeadingIn
  },
  data () {
    return {
      options: [{
          value: '1',
          label: '日'
        }, {
          value: '2',
          label: '周'
        },{
          value: '3',
          label: '月'
        },
        {
          value: '4',
          label: '年'
        }
      ],
      Dform: {
          titleValue: '',
          schoolValue: '',
          startTime : '',
          terminalTime: '',
          // currentPage3: 5,
          // pageSize3: 100,
      },
      matchTime: [],
      tableData: [{
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          zhuangtai: '已确认',
          laiyuan: '中国电信',
          defern: '10',
          IMEIdata: '860590040163569',
          danwei:'A梅江初中',
          shoujihao: '14766475671',
        }, {
          date:'2016-09-11',
          name:'shilina',
          address:'河北省石家庄市桥西区西岗头',
          zhuangtai:'待确认',
          laiyuan:'长颈鹿庄园',
          defern: '10',
          IMEIdata:'860590040163569',
          danwei:'研发',
          shoujihao:'19948067559',
        }
      ],
      multipleSelection: [],
      reviseShow: false,
      LeadingInShow: false
    }
  },
  created() {

  },
  methods: {
      inquiryClick( ) {
          // console.log(this.Dform,this.Dform.titleValue);
          // console.log(this.matchTime);
      },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection,val,'this.multipleSelection');
      // console.log(this.multipleSelection.[Target]);
    },
    derive () {
      console.log('导出');
    },
    leadingIn () {
      console.log('导入');
      this.LeadingInShow = true
    },
    fatherleadingInShow () {
      this.LeadingInShow = false
    },
    handleSizeChange (val) {
      console.log(`${val} items pr page`)
    },
    handleCurrentChange (val) {
      console.log(`分页: ${val}`)
    },
    revise (item) {
      console.log(item);
      this.reviseShow = true
    },
    fatherReviseShow () {
      this.reviseShow = false
    },
    affirm (item) {
      console.log('确认',item);
    },
 
  },
  filters: {
    // hanzi (val) {
    // if( val(/^[\u4E00-\u9FA5]{1,}$/) ){
    //   return alert('汉字');
    //   }else{
    //   return alert('其他');
    //   } 
    //}
  }
}
</script>

<style lang='scss' scoped>
.fuzzy-matching-box {
 padding-top: 20px;
  // overflow: hidden;
  // overflow: auto;
  width: 100%;
  height:  92%;
  background-color: #fff;
  // color: ;
  border-radius: 8px;
  .title-top {
      padding: 20px 20px;
  }
  .fuzzy-matching-top {
    height: 120px ;
    background-color: #fff;
    border-radius: 8px;
    .top-first-line {
      // justify-content: center 
      // justify-content: space-between
      // justify-content: space-around;
      :deep() {
        .el-col-4{
          margin-top: 5px;
          color: black;
        }
        // .el-select .el-input__wrapper{
        //   // border: solid 1px;
        // }
        .el-form-item--small .el-form-item__label {
          // background-color: red;
          font-size: 16px;
        }
        .el-select--small {
            width: 100%
        }
       
        .el-form-item--small .el-form-item__label {
          width: 120px;
          text-align: right;
          height: 35px;
          line-height: 35px;          
          font-weight: 700;
          // color: black;
        }
        .el-input {
          // color: black;
          width: 35%;
          height: 35px;
          // width: 50px;
        }
      }
    }
    .the-second-line {
      margin-top: 15px;
      position: relative;
      .query-button {
        position: absolute;
        right: 320px;
        padding: 16px 24px;
        // top: 50%;
        // transform: translate(0,-50%);
      }
    }
    :deep() {
      .el-range-editor--small.el-input__wrapper {
        height: 35px;
        line-height: 35px;  
      }
    
    }
  }
  .fuzzy-matching-bottom {
    height: calc(100% - 170px);
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 10px;
    margin-top: -55px;
    background-color: #fff;
    border-radius: 8px;
    
    .top-first-line {
      height: 45px;
      line-height: 45px;
        :deep(.tip-button) {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        :deep(.el-button--small) {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
        }
      }
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      :deep() {
        // .el-checkbox.el-checkbox--small .el-checkbox__inner {
        //   width: 18px;
        //   height: 18px;
        // }
        // .el-checkbox:last-of-type {
        //   margin-right: -1px;
        // }
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          user-select: none;
          font-size: 14px;
        }
         .manipulate {
          color: red;
          margin-right:15px;
          cursor: pointer;
          user-select: none;
        }
        .confirm,.duplicate,.revise {
          color:#1677FF;
          
        }
        .el-table th.el-table__cell>.cell {
          text-align: center;
        }
        .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }
  
}
</style>


